export default {
  existing_documents: {
    description:
      'Olet jo ladannut seuraavat asiakirjat. Valitse yksi ja paina lähetä, tai lataa sen sijaan uusi asiakirja.',
    sides: {
      front: 'Etupuoli',
      back: 'Takapuoli',
    },
    created_at: 'Ladattu: {{date}}',
    expires_at: 'Vanhenee: {{date}}',
  },
  document_types: {
    owner_document: 'Omistajan henkilöllisyysasiakirja',
    business_document: 'Yritysasiakirja',
  },
  form: {
    document_type: {
      label: 'Yritystodistusasiakirja',
      placeholder: 'Valitse asiakirjan tyyppi',
      options: {
        vat_registration: 'ALV-rekisteröinti',
        trade_registration: 'Kaupparekisteriote',
        trade_license: 'Elinkeinolupa',
        commercial_register_extract: 'Kaupparekisteriote',
        financial_statements: 'Tilinpäätös',
        other: 'Muu',
      },
    },
    front: {
      label: 'Asiakirjan etupuoli',
    },
    back: {
      label: 'Asiakirjan takapuoli (valinnainen joillekin asiakirjoille)',
    },
    expires_at: {
      label: 'Asiakirjan voimassaolon päättymispäivä',
      placeholder: 'Valitse viimeinen voimassaolopäivä',
    },
  },
  buttons: {
    select_file: 'Valitse tiedosto',
    next: 'Seuraava',
    back: 'Takapuoli',
    send: 'Lähetä',
    upload_new: 'Lataa uusi asiakirja',
    use_existing: 'Käytä ladattua asiakirjaa',
  },
};
